import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import Image from 'src/components/atoms/image';
import config from 'src/config';

import CompanyAddress from './companyAddress';

const DescriptionAndAddress = () => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Image
        style={{
          width: '157px',
          objectFit: 'contain',
        }}
        alt="SkillLane"
        src={`${config.IMAGE_CDN_HOST}/assets/logo.png`}
        errorImage={`${config.IMAGE_CDN_HOST}/assets/logo.png`}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="body2lanna" color={theme.palette.textV2.primary}>
          {t('home.footer.overview_1')}
        </Typography>
        <Typography variant="body2lanna" color={theme.palette.textV2.primary}>
          {t('home.footer.overview_2')}
        </Typography>
      </Box>
      <CompanyAddress name={t('home.footer.company.name.th')} address={t('home.footer.company.address.th')} />
      <CompanyAddress name={t('home.footer.company.name.en')} address={t('home.footer.company.address.en')} />
    </Box>
  );
};

export default DescriptionAndAddress;
